import { createRoot } from 'react-dom/client'
import { LicenseInfo } from '@mui/x-license'

import '@/modules/i18n/i18n'

import App from './app'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
// Semantic UI's global base (reset + site typography), vendored from semantic-ui-css 2.5.0 so we can
// drop the dependency while keeping the app's 14px-rem baseline, box-sizing reset, Lato/heading/link
// defaults byte-identical. All semantic `.ui.*` component CSS is intentionally NOT vendored — every
// component is migrated to MUI. See web/fe/docs/semantic-to-mui-migration.md.
import './scss/vendor/semantic-reset.css'
import './scss/vendor/semantic-site.css'
import './scss/stylesheet.scss'

LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_LICENSE_KEY)

// This is to be used when using MSW in development in the browser.
// if (import.meta.env.DEV && !import.meta.env.VITEST) {
//   const { worker } = await import('@test/worker')
//   worker.start()
// }

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<App />)
